(function () {
  var CartButtonChaser = function () {
    this.initialize();
  };

  CartButtonChaser.prototype = {
    initialize: function () {
      this.setElements();
      this.setProps();
      this.setEvents();
    },

    setElements: function () {
      this.$win = $(window);
      this.$body = $('body');
      this.$cartButton = $('.js-cart-button');
    },

    setProps: function () {
      if (!this.$cartButton.length) {
        return;
      }

      this.cartButtonFixedClass = 'p-cart-button--fixed';
      this.cartButtonOuterHeight = this.$cartButton.outerHeight();

      // カートボタンのオフセット位置を取得する際には
      // 確実にfixed用のクラスを削除しておかないと位置計算がおかしくなる
      this.$cartButton.removeClass(this.cartButtonFixedClass);
      this.startChasingPosition =
        this.$cartButton.offset().top + this.cartButtonOuterHeight;
    },

    setEvents: function () {
      if (!this.$cartButton.length) {
        return;
      }

      this.$win
        .off('scroll.cartbuttonchaser')
        .on('scroll.cartbuttonchaser', this.setPosition.bind(this));
    },

    setPosition: function () {
      if (!this.$cartButton.length) {
        return;
      }

      var scrollBottom = this.$win.scrollTop() + this.$win.height();
      var startChasing = scrollBottom > this.startChasingPosition;
      var method = startChasing ? 'addClass' : 'removeClass';
      var bodyPaddingBottom = startChasing ? this.cartButtonOuterHeight : 0;

      this.$cartButton[method](this.cartButtonFixedClass);
      this.$body.css('padding-bottom', bodyPaddingBottom);
    },

    rePosition: function () {
      this.setProps();
      this.setPosition();
    }
  };

  window.detailsVueMixin = {
    methods: {
      onFetchData: function () {
        // カートボタンエリアの追従
        var cartButtonChaser = new CartButtonChaser();

        // メイン画像の高さが確定した際にカートボタンの位置が変わるので都度叩く
        $(this.$refs['main-image-viewer']).on(
          'lazyLoaded setPosition',
          function () {
            cartButtonChaser.rePosition();
          }
        );
      }
    }
  };
})();
